import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './FeedbackBanner.css';

const RATED_KEY   = 'vm_play_rated';
const DISMISS_KEY = 'vm_play_dismissed';
const COOLDOWN_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.techscriptaid.voicemeetpro';

function openPlayStore() {
  const isAndroid = /android/i.test(navigator.userAgent);
  window.location.href = isAndroid
    ? 'market://details?id=com.techscriptaid.voicemeetpro'
    : PLAY_STORE_URL;
}

function shouldShow() {
  if (localStorage.getItem(RATED_KEY)) return false;
  const dismissed = localStorage.getItem(DISMISS_KEY);
  if (!dismissed) return true;
  return Date.now() - parseInt(dismissed, 10) > COOLDOWN_MS;
}

export default function FeedbackBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(shouldShow()), 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleRate = () => {
    localStorage.setItem(RATED_KEY, Date.now().toString());
    setVisible(false);
    openPlayStore();
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, Date.now().toString());
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fb-banner"
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
        >
          <span className="fb-banner__star">⭐</span>
          <span className="fb-banner__text">
            Enjoying VoiceMeet Pro? <strong>Rate us on Google Play</strong> — it takes 10 seconds.
          </span>
          <button className="fb-banner__cta" onClick={handleRate}>
            Rate Now
          </button>
          <button className="fb-banner__dismiss" onClick={handleDismiss} aria-label="Dismiss">
            ✕
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
